import React, { useState } from "react";
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from "./HeroElements";
import Video from "../../video/HeroVideo.mp4";
import { Button } from "../../components/ButtonElement/Button";

const Hero = () => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer id="home">
      <HeroBg>
        <VideoBg autoPlay loop muted src={Video} playsinline type="video/mp4" />
      </HeroBg>
      <HeroContent>
        <HeroH1> Grădiniţa “Roza Venerini” </HeroH1>
        <HeroP>
          “Ceea ce vine din inima dureaza mai mult, este mai adevarat si este
          mai aproape de temperamentul copiilor”
        </HeroP>
        <HeroBtnWrapper>
          <Button
            to="groups"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
            primary="true"
            dark="true"
            onMouseEnter={onHover}
            onMouseLeave={onHover}
          >
            Vezi Grupele {hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;
